export function getQueryVariableByName(name: string): string | null {
    const half = window.location.search.split(name + '=')[1];
    return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
}
